import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLocationPin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 30,
	zoomAndPan: "magnify",
	viewBox: "0 0 22.5 34.5",
	height: 46,
	preserveAspectRatio: "xMidYMid meet",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "cb27f60843",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M 0 0.128906 L 22 0.128906 L 22 33.878906 L 0 33.878906 Z M 0 0.128906 ",
			clipRule: "nonzero"
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#cb27f60843)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M 10.984375 0.320312 C 4.914062 0.320312 -0.0078125 5.242188 -0.0078125 11.316406 C -0.0078125 17.382812 10.984375 33.292969 10.984375 33.292969 C 10.984375 33.292969 21.972656 17.382812 21.972656 11.316406 C 21.972656 5.242188 17.050781 0.320312 10.984375 0.320312 Z M 10.984375 16.519531 C 7.789062 16.519531 5.199219 13.929688 5.199219 10.734375 C 5.199219 7.539062 7.789062 4.953125 10.984375 4.953125 C 14.179688 4.953125 16.765625 7.539062 16.765625 10.734375 C 16.765625 13.929688 14.179688 16.519531 10.984375 16.519531 Z M 10.984375 16.519531 ",
			fillOpacity: 1,
			fillRule: "nonzero"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M 10.984375 0.320312 C 4.914062 0.320312 -0.0078125 5.242188 -0.0078125 11.316406 C -0.0078125 17.382812 10.984375 33.292969 10.984375 33.292969 C 10.984375 33.292969 21.972656 17.382812 21.972656 11.316406 C 21.972656 5.242188 17.050781 0.320312 10.984375 0.320312 Z M 10.984375 16.519531 C 7.789062 16.519531 5.199219 13.929688 5.199219 10.734375 C 5.199219 7.539062 7.789062 4.953125 10.984375 4.953125 C 14.179688 4.953125 16.765625 7.539062 16.765625 10.734375 C 16.765625 13.929688 14.179688 16.519531 10.984375 16.519531 Z M 10.984375 16.519531 ",
			fillOpacity: 1,
			fillRule: "nonzero"
		})]
	})]
});
export default SvgLocationPin;
